import { HTTPMethod } from '@/lib/requests/types'
import { UserId } from '@/types/common'
import {
	InvitePendingUsersSuccessZ,
	SetIsFlightSearchMockEnabledRequestZ,
	SetIsMockEnabledRequestZ,
	SetIsObFeeMockEnabledRequestZ,
	SetIsTokenizerMockEnabledRequestZ,
	SetIsWorldlineMockEnabledRequestZ,
	User,
} from '@/types/user'
import { ObFeeMockValue, UserNewZ } from '@/types/userNew'

import { getGGClient, RequestOverrides } from './GetGoingClient'

export async function setIsMockEnabled(userId: UserId, value: boolean, overrides?: RequestOverrides) {
	return getGGClient()
		.request('PUT', `users/${userId}/mock`, {
			requestSchema: SetIsMockEnabledRequestZ,
			responseSchema: UserNewZ,
			data: {
				mock_enabled: value,
			},
			...overrides,
		})
		.then((r) => r.data as User)
}

export async function setIsTokenizerMockEnabled(userId: UserId, value: boolean, overrides?: RequestOverrides) {
	return getGGClient()
		.request('PUT', `users/${userId}/tokenizer_mock`, {
			requestSchema: SetIsTokenizerMockEnabledRequestZ,
			responseSchema: UserNewZ,
			data: {
				tokenizer_mock_enabled: value,
			},
			...overrides,
		})
		.then((r) => r.data as User)
}

export async function setIsWorldlineMockEnabled(userId: UserId, value: boolean, overrides?: RequestOverrides) {
	return getGGClient()
		.request('PUT', `users/${userId}/worldline_mock`, {
			requestSchema: SetIsWorldlineMockEnabledRequestZ,
			responseSchema: UserNewZ,
			data: {
				worldline_mock_enabled: value,
			},
			...overrides,
		})
		.then((r) => r.data as User)
}

export async function setIsFlightSearchMockEnabled(userId: UserId, value: boolean, overrides?: RequestOverrides) {
	return getGGClient()
		.request('PUT', `users/${userId}/flight_search_mock`, {
			requestSchema: SetIsFlightSearchMockEnabledRequestZ,
			responseSchema: UserNewZ,
			data: {
				flight_search_mock_enabled: value,
			},
			...overrides,
		})
		.then((r) => r.data as User)
}

export async function setIsObFeeMockEnabled(
	userId: UserId,
	value: ObFeeMockValue | null,
	overrides?: RequestOverrides,
) {
	return getGGClient()
		.request(HTTPMethod.PUT, `users/${userId}/ob_fee_mock`, {
			requestSchema: SetIsObFeeMockEnabledRequestZ,
			responseSchema: UserNewZ,
			data: {
				ob_fee_mock: value,
			},
			...overrides,
		})
		.then((r) => r.data as User)
}

export async function sendPendingInvites(companyId: number) {
	const url = `users/bulk_invite/${companyId}`

	return await getGGClient().simplePollingRequest(url, {
		resultSchema: InvitePendingUsersSuccessZ,
	})
}
